import React from "react";
import Accordion from "../../common/accordion";

export default function FaqAccordion({ items }) {
  return <Accordion faqs={items} />;
}
